import type {
  Collection,
  CollectionFormData,
  CollectionItem,
  CollectionModalContent,
  CollectionsSummaryTab,
} from "./collection.types";
import type { AsyncStatus } from "../redux/base.state";
import type { Pagination } from "../../../types/pagination.types";

export interface CollectionState {
  // main list
  data: Collection[] | null;
  status: AsyncStatus;
  error: string | null;

  modalContent: CollectionModalContent | null;

  // selected collection (detail page)
  selectedCollection: Collection | null;
  selectedCollectionStatus: AsyncStatus;
  selectedCollectionError: string | null;
  selectedCollectionItems: CollectionItem[];
  selectedCollectionPagination: Pagination | null;

  // form
  formData: CollectionFormData | null;
  formDataStatus: AsyncStatus;
  formDataError: string | null;

  // followed
  followedCollections: Collection[] | null;
  followedCollectionsStatus: AsyncStatus;
  followedCollectionsError: string | null;

  // summary tabs
  summaryTabList: CollectionsSummaryTab[] | null;
  summaryStatus: AsyncStatus;
  summaryError: string | null;

  // UI flags
  isCreating: boolean;
  isUpdating: boolean;
  isDeleting: boolean;
  isAddingItem: boolean;
  isRemovingItem: boolean;
  isTogglingFollow: boolean;
}

export const initialCollectionState: CollectionState = {
  data: null,
  status: "idle",
  error: null,

  modalContent: null,

  selectedCollection: null,
  selectedCollectionStatus: "idle",
  selectedCollectionError: null,
  selectedCollectionItems: [],
  selectedCollectionPagination: null,

  formData: null,
  formDataStatus: "idle",
  formDataError: null,

  followedCollections: null,
  followedCollectionsStatus: "idle",
  followedCollectionsError: null,

  summaryTabList: null,
  summaryStatus: "idle",
  summaryError: null,

  isCreating: false,
  isUpdating: false,
  isDeleting: false,
  isAddingItem: false,
  isRemovingItem: false,
  isTogglingFollow: false,
};
